import { render, staticRenderFns } from "./AffiliateGroups.list.vue?vue&type=template&id=68d4bbdc&"
import script from "./AffiliateGroups.list.vue?vue&type=script&lang=js&"
export * from "./AffiliateGroups.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports